var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.id,
            "hide-footer": "",
            centered: "",
            "header-close-label": _vm.$t("Btn_Close")
          },
          on: {
            shown: function($event) {
              return _vm.focusTextArea()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _c("label", { attrs: { for: _vm.id + "-dialogtextarea" } }, [
                    _vm._v(_vm._s(_vm.$t(_vm.title)))
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "d-block text-center" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.modifiedValue,
                    expression: "modifiedValue"
                  }
                ],
                ref: "focusThis",
                staticClass: "form-control",
                attrs: {
                  placeholder: _vm.$t(_vm.placeholder),
                  readOnly: _vm.isReadOnly,
                  maxlength: _vm.maxLength,
                  rows: _vm.rows,
                  id: _vm.id + "-dialogtextarea"
                },
                domProps: { value: _vm.modifiedValue },
                on: {
                  focus: function($event) {
                    return _vm.touch()
                  },
                  change: function($event) {
                    return _vm.change()
                  },
                  blur: function($event) {
                    return _vm.onBlur()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.modifiedValue = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              !_vm.isReadOnly
                ? _c("div", { staticClass: "mt-2 charsleft-label" }, [
                    _c("div", { staticClass: "float-left" }, [
                      _c("i", { staticClass: "fas fa-asterisk icon red" }),
                      _vm._v(" " + _vm._s(_vm.$t("Validation.required")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "float-right" }, [
                      _vm._v(
                        _vm._s(_vm._f("formatNumber")(_vm.charsLeft)) +
                          " " +
                          _vm._s(_vm.$t("CharsLeft"))
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }